<template>
  <div>
    <div class="pt-5" v-if="category === 'quick-links' && links.length > 0">
      <div
        class="d-flex justify-content-start align-items-center"
        v-if="disclaimer !== ''"
        style="background: #434141; padding: 12px 20px; border-radius: 4px; gap: 10px;"
      >
        <img src="@/assets/images/IconWarning.svg" alt="" srcset="" />
        <span style="font-size: 14px;">{{ disclaimer }}</span>
      </div>
      <div v-if="$root.mode === 'xs' || $root.mode === 'sm'" class="reveal">
        <div class="items">
          <div class="item mb-5" v-for="(item, key) in links">
            <template>
              <div v-if="disclaimer === ''" style="display: none;">
                {{
                  (disclaimer =
                    item &&
                    item.href &&
                    item.href.toLowerCase().includes("disclaimer")
                      ? item.name
                      : "")
                }}
              </div>
              <div v-if="!item.href.toLowerCase().includes('disclaimer')">
                <div
                  v-bind:class="{
                    'is-active': active.some((element) => {
                      return element === key;
                    }),
                  }"
                  v-on:click="toggle(key, item.name)"
                  v-bind:id="item.name | sanitize"
                  v-bind:ref="item.name | sanitize"
                >
                  <p class="pr-5 heading">{{ item.name }}</p>
                </div>
                <div
                  class="mb-5 pr-md-5 content"
                  v-show="
                    active.some((element) => {
                      return element === key;
                    })
                  "
                >
                  <!-- <h6 class="sub-head py-2">{{ item.name }}</h6> -->
                  <ul class="items pl-0">
                    <li v-for="link in item.children">
                      <a
                        v-bind:href="link.href"
                        v-bind:target="link.target"
                        v-html="link.name"
                      ></a>
                    </li>
                  </ul>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>

      <div v-else>
        <div class="row" v-if="category === 'quick-links'">
          <div v-for="(item, key) in links" class="col-md-4 pt-5">
            <template>
              <div v-if="disclaimer === ''" style="display: none;">
                {{
                  (disclaimer =
                    item &&
                    item.href &&
                    item.href.toLowerCase().includes("disclaimer")
                      ? item.name
                      : "")
                }}
              </div>
              <div v-if="!item.href.toLowerCase().includes('disclaimer')">
                <div class="pb-3">
                  <p class="pr-5 menu-title">{{ item.name }}</p>
                </div>
                <div class="mb-5 pl-md-1">
                  <ul class="quick-links">
                    <li v-for="link in item.children" class="d-block w-100">
                      <a
                        v-bind:href="link.href"
                        v-bind:target="link.target"
                        v-html="link.name"
                      ></a>
                    </li>
                  </ul>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>

    <div class="copyright row mx-0" v-if="category === 'useful-links'">
      <p class="d-block d-md-none">
        {{ $getTranslation("Copyright", $route.params.region) }} ©
        {{ new Date().getFullYear() }} ResMed.
        {{ $getTranslation("All rights reserved.", $route.params.region) }}
      </p>
      <div class="col-md-8 px-0">
        <ul class="useful-links pl-0 row mx-0">
          <li
            class="list-inline-item"
            v-bind:class="{ 'col-md-4 px-0': $root.mode !== 'xs' }"
            v-for="(item, i) in items"
          >
            <a
              v-bind:href="item.href"
              v-bind:target="item.target"
              class="pr-2 footer-link"
              >{{ item.name }}</a
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "footer-navigation",
  props: ["category"],
  data() {
    return {
      menu: [],
      data: [],
      active: [],
      items: [],
      links: [],
      disclaimer: "",
    };
  },
  created() {
    let address = process.env.VUE_APP_API_ENDPOINT;

    // Get top menu bar links
    const site = `${address}/${
      this.$route.params.region
    }/wp-json/resmed/v1/navigation/footer-useful-links`;
    const footerMenu = `${address}/${
      this.$route.params.region
    }/wp-json/resmed/v1/navigation/footer-menu`;

    // Footer quick links - footer-menu
    axios.get(footerMenu).then((response) => {
      this.links = response.data;
    });

    // Footer link - footer-useful-links
    axios.get(site).then((response) => {
      this.items = response.data;
    });
  },
  filters: {
    sanitize(value) {
      return value
        .replace(/\s/g, "-")
        .toLowerCase()
        .replace(/&/g, "and");
    },
  },
  methods: {
    toggle(key, question) {
      // use polyfill instead
      let item = -1;
      this.active.some((element, index) => {
        if (element === key) {
          item = index;
          return true;
        }
      });
      // end polyfill

      if (item === -1) {
        this.active.push(key);

        this.$root.datalayer.push({
          event: "faqClick",
          faqClick: question,
        });
      } else {
        this.active.splice(item, 1);
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.reveal {
  padding: 2rem 0 0;
  width: 100%;
  display: block;

  .item {
    ul,
    ol {
      margin: 1rem 0;
      padding-left: 2rem;
    }
    .heading {
      font-family: "Plus Jakarta Sans", Arial, sans-serif;
      font-weight: 700;
    }
  }

  p {
    position: relative;
    margin-bottom: 1.5rem;
    padding-bottom: 1.5rem;
    border-bottom: 1px solid $cc-resmed-grey-30;
    cursor: pointer;

    &:after {
      content: "";
      position: absolute;
      right: 0;
      top: -2px;
      display: block;
      width: 1.75rem;
      height: 1.75rem;
      border-radius: 50%;
      // background-color: $cc-resmed-action-red;
      // background-size: 1rem 1rem;
      background-position: center center;
      background-repeat: no-repeat;
      background-image: url(#{$assets}/images/icon-move-expand-red.svg);
    }
  }

  .is-active {
    p {
      &:after {
        background-image: url(#{$assets}/images/buttons-glyphs-plus.png);
      }
    }
  }
  .items {
    .sub-head {
      font-family: "Plus Jakarta Sans", Arial, sans-serif;
      font-weight: bold;
      color: #6f6f6f;
      font-size: 1rem;
    }
    li {
      a {
        font-family: "Plus Jakarta Sans", Arial, sans-serif;
        font-size: 0.875rem;
        color: #fff;
      }
    }
  }
}

.useful-links {
  .list-inline-item {
    display: inline-block;
    padding-right: 0.725rem;
    a {
      color: #fff;
      font-family: "Plus Jakarta Sans", Arial, sans-serif;
      @media (max-width: 480px) {
        color: #707070;
        font-size: 0.875rem;
      }
    }
  }
}

.footer-link {
  font-size: 0.875rem; // 14px for desktop
  font-weight: 400;
  line-height: 1.5;
  
  @media (max-width: 767px) {
    font-size: 0.75rem; // 12px for mobile
  }
}
.copyright {
  p {
    font-family: "Plus Jakarta Sans", Arial, sans-serif;
    font-size: 0.875rem;
    @media (max-width: 480px) {
      opacity: 0.8;
    }
  }
}
.quick-links {
  column-count: 1;
  li {
    a {
      color: #fff;
    }
  }
}
.menu-title {
  &::before {
    content: "";
    display: block;
    width: 1.25rem;
    border-top: 3px solid #fff;
    border-radius: 5.5px;
    margin: -3px 0 16px;
  }
}
</style>
